/* optGlideTo v1 (2026-09-07) — the shared "take me to the bundles" motion.
   Three constraints have to hold at once on this page:
     · It must feel like a scroll, not a teleport. A hard jump reads as a page reload.
     · It must not glide the full ~13,000 px from the closing CTA: that outruns the
       renderer past 15 content-visibility:auto sections and paints blank (measured 89 KB
       vs a 1,433 KB steady-state frame — the "white screen" the owner reported).
     · It must not lean on CSS scroll-behavior:smooth, because a native smooth scroll is
       an animation the browser abandons on user input, on a layout shift under it, and
       entirely while the tab is hidden — measured 0 px of movement in that state.
   So: close any distance beyond ~1.6 viewports instantly (nobody perceives those pixels
   anyway), then animate the last stretch ourselves with easeOutCubic so it decelerates
   into the bundle selector. Every frame forces behavior:'instant', which is what makes a
   hand-rolled animation safe here — the bare scrollTo(0,y) form inherits smooth and would
   put the two animations back in conflict. */
function optJumpTo(y) {
  try { window.scrollTo({ top: y, behavior: 'instant' }); }
  catch (err) { window.scrollTo(0, y); }   // pre-2022 browsers: no options object
}
function optGlideTo(targetY, onDone) {
  targetY = Math.max(0, Math.round(targetY));
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var start = window.scrollY || window.pageYOffset || 0;
  if (reduced || Math.abs(targetY - start) < 4) {
    optJumpTo(targetY);
    if (onDone) onDone();
    return;
  }
  var runway = window.innerHeight * 1.6;
  if (Math.abs(targetY - start) > runway) {
    // Land a screen and a half out, in the direction we are travelling from.
    optJumpTo(targetY + (targetY < start ? runway : -runway));
    start = window.scrollY || window.pageYOffset || 0;
  }
  var distance = targetY - start;
  var duration = Math.min(950, Math.max(480, Math.abs(distance) * 0.75));
  // Let the browser actually PAINT where we just landed before the glide starts.
  // One frame is not enough at devicePixelRatio 2 — measured 1 near-blank frame in 9 on a
  // 1512x772 @2x viewport with a single rAF, 0 in 9 with two. The first rAF fires before
  // the paint that follows the jump; the second fires after it, so the glide begins on
  // rendered content instead of racing the compositor.
  requestAnimationFrame(function () {
   requestAnimationFrame(function () {
    var t0 = performance.now();
    (function step(now) {
      var t = Math.min(1, (now - t0) / duration);
      var eased = 1 - Math.pow(1 - t, 3);   // easeOutCubic: quick away, gentle arrival
      optJumpTo(Math.round(start + distance * eased));
      if (t < 1) { requestAnimationFrame(step); }
      else { optJumpTo(targetY); if (onDone) onDone(); }
    })(performance.now());
   });
  });
}

/* theme.liquid inline script (was L818) */
(function () {
        /* opt-shopnow-scroll-fix v3 */
        var bar = document.getElementById('opt-shopnow-bar');
        var btn = document.getElementById('opt-shopnow-btn');
        if (!bar || !btn) return;
        /* opt-shopnow-bar v7 — pdp threshold = past bundles */
        // On PDP: appear only after the user has scrolled past the bundle selector
        // (so the bar shows up around "The Ruffes Difference" / sections below the bundles).
        // On home: keep the simple 400px reveal.
        var isProduct = btn.getAttribute('data-target') === 'bundles';
        function computeThreshold() {
          if (!isProduct) return 400;
          var bundleEl = document.querySelector('[id^="obs-"]');
          if (bundleEl) {
            var rect = bundleEl.getBoundingClientRect();
            var bottomY = rect.top + (window.scrollY || window.pageYOffset) + bundleEl.offsetHeight;
            return Math.max(800, Math.round(bottomY - 60));
          }
          return 1200; // fallback when bundle block isn't found
        }
        var threshold = computeThreshold();
        // Recompute on resize (layout shifts can change where bundles sit)
        var resizeT;
        window.addEventListener('resize', function () {
          clearTimeout(resizeT);
          resizeT = setTimeout(function () { threshold = computeThreshold(); onScroll(); }, 150);
        });
        // And recompute once images settle on the page
        window.addEventListener('load', function () { threshold = computeThreshold(); onScroll(); });
        bar.hidden = false;
        var programmatic = false;  // true while we own the scroll — ignore visibility toggles
        /* v13 (2026-09-26) — never cover the cart drawer (its checkout button) or the welcome popup.
           The bar steps aside while either is open; body.opt-bar-active (the footer padding) stays,
           so the page does not jump underneath the overlay. */
        function overlayOpen() {
          var d = document.querySelector('cart-drawer');
          return !!((d && d.classList.contains('active')) || document.querySelector('#opt-wp.opt-wp-on'));
        }
        function setVisible(on) {
          var ov = overlayOpen();
          document.body.classList.toggle('opt-overlay-open', ov);
          bar.classList.toggle('opt-visible', on && !ov);
          document.body.classList.toggle('opt-bar-active', on);
        }
        function onScroll() {
          if (programmatic) return;
          var y = window.scrollY || window.pageYOffset;
          setVisible(y > threshold);
        }
        /* Watch <body>, not the drawer: adding to cart re-renders the cart-drawer section and replaces
           the element, but the drawer always toggles overflow-hidden on <body> when it opens/closes. */
        if (window.MutationObserver) {
          /* The drawer adds .active a frame or two after it locks <body>, so check again once it settles. */
          var ovT;
          var recheck = function () { setVisible((window.scrollY || window.pageYOffset) > threshold); };
          var ovMo = new MutationObserver(function () { recheck(); clearTimeout(ovT); ovT = setTimeout(recheck, 120); });
          ovMo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
          var wp = document.getElementById('opt-wp');
          if (wp) ovMo.observe(wp, { attributes: true, attributeFilter: ['class'] });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        /* v15 (2026-09-27) — on the Drops PDP the bar shows only once the main Add to cart button has scrolled
           up off the screen, so it never covers the pack picker on the way down. */
        var mainBtn = isProduct && document.querySelector('.opt-obx .obx-btn');
        if (mainBtn && 'IntersectionObserver' in window) {
          var baseSetVisible = setVisible;
          computeThreshold = function () { return -1; };
          threshold = -1;
          /* read the button position on every check, so a fast jump down the page still counts */
          setVisible = function (on) { baseSetVisible(on && mainBtn.getBoundingClientRect().bottom < 0); };
        }
        onScroll();

        /* opt-shopnow-bar v9 (2026-09-07) — native scrolling.
           The old easeInOutCubic rAF loop called window.scrollTo() every frame,
           but optistasis-overrides-product.css sets html{scroll-behavior:smooth},
           so EVERY one of those calls started a fresh native smooth-scroll that the
           next frame immediately cancelled. Measured result: ~860 ms where the page
           did not move at all after the tap, then a 1.5 s glide once the JS loop
           finally stopped issuing calls — ~2.3 s total, the first second looking dead.
           Issuing ONE native scroll does the same job correctly and instantly. */
        function scrollToTop() { scrollToY(0); }

        function scrollToTarget() {
          /* opt-shopnow-bar v8 home-redirect — home now redirects to PDP */
          var target = btn.getAttribute('data-target');
          if (target === 'navigate') {
            var href = btn.getAttribute('data-href');
            if (href) { window.location.href = href; return; }
          }
          if (target === 'bundles') {
            var bundleEl = document.querySelector('[id^="obs-"]');
            if (bundleEl) {
              var rect = bundleEl.getBoundingClientRect();
              var top = (window.scrollY || window.pageYOffset) + rect.top - 80;
              if (top < 0) top = 0;
              return scrollToY(top);
            }
          }
          scrollToTop();
        }
        var settleT;
        /* v12 (2026-09-07) — long jumps must be instant, not smooth.
           Captured at Retina density: gliding the ~13,000 px from the closing CTA up to the
           bundle block forces the browser to paint all 15 content-visibility:auto sections on
           the way past, and it cannot keep up — a mid-scroll frame came back at 89 KB against a
           1,433 KB steady state, i.e. rendered blank. On a cream page that reads as a white
           screen, and on a 2x display it lasts seconds. Jumping paints only the destination:
           0 blank frames out of 8, same landing position. So glide only when the trip is short
           enough to stay rendered, and jump when it is not. */
        function releaseScroll() { clearTimeout(settleT); programmatic = false; }
        function scrollToY(targetY) {
          var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var start = window.scrollY || window.pageYOffset || 0;
          if (Math.abs(start - targetY) < 2) return;
          programmatic = true;
          optGlideTo(targetY);
          // Hide the bar immediately when heading back to the top (home behaviour).
          if (targetY === 0) setVisible(false);
          // Hand visibility control back once the native scroll has settled. Re-entrant
          // by design: a second tap just re-targets the same native scroll instead of
          // stacking a second animation, which is what made repeat taps judder.
          clearTimeout(settleT);
          settleT = setTimeout(function () { programmatic = false; onScroll(); }, prefersReduced ? 60 : 900);
          verifyArrival(targetY);
        }
        /* v10 — a native smooth scroll is an animation the browser is free to abandon:
           real scroll input cancels it, a layout shift under it cancels it (this page has
           15 content-visibility:auto sections that change the document height mid-flight),
           and it does not run at all while the tab is hidden or occluded — measured 0 px of
           movement in that state, in two different browsers. When it is abandoned the CTA
           silently does nothing, which is indistinguishable from a dead button. So: watch
           the scroll, and if it stops short or never starts, finish the job instantly. */
        function verifyArrival(targetY) {
          var tries = 0, lastY = null;
          var iv = setInterval(function () {
            tries++;
            var y = window.scrollY || window.pageYOffset;
            if (Math.abs(y - targetY) < 40) { clearInterval(iv); return; }   // arrived
            if ((lastY !== null && Math.abs(y - lastY) < 2) || tries > 8) {  // stalled, or out of patience
              clearInterval(iv);
              /* behavior:'instant' is required, not optional. The bare scrollTo(0,y) form
                 still obeys the CSS scroll-behavior:smooth on <html>, so the rescue would
                 itself be the abandonable animation it exists to rescue. */
              try { window.scrollTo({ top: targetY, behavior: 'instant' }); }
              catch (err) { window.scrollTo(0, targetY); }
            }
            lastY = y;
          }, 250);
        }
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          /* v13 — on the Drops PDP the bundle script sets data-obx-add, and the bar shows the selected
             pack and price, so the button adds that selection directly. Tapping the product side of the
             bar still scrolls back to the selector to change it. */
          var addBid = btn.getAttribute('data-obx-add');
          if (addBid && typeof window.obsClick_atc === 'function') { window.obsClick_atc(addBid); return; }
          scrollToTarget();
        });
        // Delegated: if product-row is rendered as a button (PDP), clicking it also scrolls to bundles
        var productBtn = bar.querySelector('.opt-bar-product-btn');
        if (productBtn) {
          productBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            scrollToTarget();
          });
        }
        // If the user grabs the page mid-scroll, the browser cancels its own smooth
        // scroll — so drop the settle timer too, or it would fight them 900 ms later.
        window.addEventListener('wheel', releaseScroll, { passive: true });
        window.addEventListener('touchmove', releaseScroll, { passive: true });
      })();
/* theme.liquid inline script (was L1014) */
(function () {
      function isPressable(el) {
        if (!el || el.nodeType !== 1) return false;
        if (el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
        var tag = el.tagName;
        if (tag === 'BUTTON') return el.type !== 'reset';
        if (tag === 'INPUT') return el.type === 'submit' || el.type === 'button';
        if (tag === 'A') {
          var cls = (el.className || '').toString();
          return /btn|button|cta|shopnow|product-form|add-to-cart|checkout|bundle|nav-button/i.test(cls);
        }
        if (el.getAttribute('role') === 'button') return true;
        return false;
      }
      function isDarkBackground(rgbStr) {
        var m = rgbStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (!m) return false;
        var r = +m[1], g = +m[2], b = +m[3];
        // Perceived luminance
        var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return lum < 0.55;
      }
      function spawnRipple(button, event) {
        var rect = button.getBoundingClientRect();
        if (rect.width < 28 || rect.height < 28) return; // skip tiny buttons
        var x = (event.clientX != null ? event.clientX : rect.left + rect.width / 2) - rect.left;
        var y = (event.clientY != null ? event.clientY : rect.top + rect.height / 2) - rect.top;
        var size = Math.max(rect.width, rect.height) * 2;
        var ripple = document.createElement('span');
        ripple.className = 'opt-ripple';
        ripple.style.left = (x - size / 2) + 'px';
        ripple.style.top = (y - size / 2) + 'px';
        ripple.style.width = size + 'px';
        ripple.style.height = size + 'px';
        // Detect bg darkness → choose cream ripple for dark buttons
        var bg = getComputedStyle(button).backgroundColor;
        if (isDarkBackground(bg)) ripple.classList.add('opt-ripple-dark-bg');
        // Make sure button is a positioning context that clips
        var cs = getComputedStyle(button);
        if (cs.position === 'static') {
          button.style.position = 'relative';
        }
        // Track original overflow so we can restore later
        if (!button.dataset.optOverflow) {
          button.dataset.optOverflow = cs.overflow;
          button.style.overflow = 'hidden';
        }
        button.appendChild(ripple);
        setTimeout(function () { ripple.remove(); }, 700);
      }
      function init() {
        document.addEventListener('pointerdown', function (e) {
          var btn = e.target.closest(
            'button, input[type="submit"], input[type="button"], a, [role="button"]'
          );
          if (!btn || !isPressable(btn)) return;
          spawnRipple(btn, e);
        }, { passive: true });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
/* theme.liquid inline script (was L1101) */
(function () {
      function positionSideNav() {
        // 1. PDP-style testimonials-carousel (written testimonials)
        document.querySelectorAll('.testimonials-carousel').forEach(function (carousel) {
          var track = carousel.querySelector('.testimonials-track')
                   || carousel.querySelector('[class*="testimonials-wrap"]')
                   || carousel.querySelector('[class*="testimonials-list"]');
          var nav = carousel.querySelector('.testimonials-navigation');
          if (!track || !nav) return;
          var h = track.offsetHeight;
          if (h > 0) {
            nav.style.top = (track.offsetTop + h / 2) + 'px';
            nav.style.transform = 'translateY(-50%)';
          }
        });
        // 2. Home-style video-testimonials-section
        document.querySelectorAll('.video-testimonials-section').forEach(function (section) {
          var container = section.querySelector('.carousel-container');
          var nav = section.querySelector('.carousel-nav');
          if (!container || !nav) return;
          var h = container.offsetHeight;
          if (h > 0) {
            nav.style.top = (container.offsetTop + h / 2) + 'px';
            nav.style.transform = 'translateY(-50%)';
          }
        });
      }
      function init() {
        positionSideNav();
        if (!('ResizeObserver' in window)) { setTimeout(positionSideNav, 1200); }
        window.addEventListener('resize', positionSideNav);
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(positionSideNav);
          document.querySelectorAll('.testimonials-carousel, .video-testimonials-section').forEach(function (c) {
            ro.observe(c);
          });
        }
      }
      function schedule() { if ('requestIdleCallback' in window) { requestIdleCallback(init, { timeout: 2500 }); } else { setTimeout(init, 200); } }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule);
      } else {
        schedule();
      }
    })();


/* opt-anchor-cta v1 (2026-09-07) — the three in-page "Choose Your Supply" links (founder,
   offer recap, closing CTA) are plain <a href="#obs-obs_bundle_block">, so they depend
   entirely on native anchor scrolling. With html{scroll-behavior:smooth} that is the same
   abandonable animation described above, and when it is abandoned the link does nothing at
   all. Drive it ourselves and confirm arrival, recomputing the target as we go because the
   content-visibility sections between here and the bundle block change height while we
   travel. replaceState rather than a hash navigation, so the back button stays clean. */
(function () {
  function scrollToEl(el) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function want() {
      var top = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 90;
      return Math.max(0, Math.round(top));
    }
    optGlideTo(want());
    var tries = 0, lastY = null;
    var iv = setInterval(function () {
      tries++;
      var y = window.scrollY || window.pageYOffset, w = want();
      if (Math.abs(y - w) < 40) { clearInterval(iv); return; }
      if ((lastY !== null && Math.abs(y - lastY) < 2) || tries > 8) {
        clearInterval(iv);
        /* must force instant — the bare form inherits scroll-behavior:smooth */
        try { window.scrollTo({ top: want(), behavior: 'instant' }); }
        catch (err) { window.scrollTo(0, want()); }
      }
      lastY = y;
    }, 250);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#obs-"]') : null;
    if (!a) return;
    var href = a.getAttribute('href');
    var el = document.getElementById(href.slice(1));
    if (!el) return;
    e.preventDefault();
    try { if (history.replaceState) history.replaceState(null, '', href); } catch (err) {}
    scrollToEl(el);
  }, true);
})();
